module.exports = __webpack_public_path__ + "img/ec22441.png";